// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"58484f50","344":"910e2d7d","699":"707900ff","707":"54a86d9f"}[chunkId] + ".chunk.js";
};